import {createReducer} from '@reduxjs/toolkit';

import {setUserAddressesAction, setSelectedAddressAction} from 'store/actions/addresses-action';
import {AddressesState} from 'store/types/addresses';

const initialState: AddressesState = {
  availableAddresses: [],
  selectedShippingAddress: undefined
};

const AddressesReducer = createReducer(initialState, (builder) => {
  builder.addCase(setUserAddressesAction, (state, action) => {
    return {
      ...state,
      availableAddresses: action?.payload
    };
  });

  builder.addCase(setSelectedAddressAction, (state, action) => {
    return {
      ...state,
      selectedShippingAddress: action.payload
    };
  });
});

export default AddressesReducer;
